export default __webpack_public_path__ + "static/media/kiraly_menu.f9edb616.png";